import { GridHeaderCellProps } from '@progress/kendo-react-grid';
import { whiteIcon } from 'src/utils/icons';

const ErrorIconHeader = (props: GridHeaderCellProps) => (
  <div
    className="flex items-center justify-center flex-grow min-w-[45px]"
    title={'Error'}
    onClick={props.onClick}
  >
    {whiteIcon}
    {props.children}
  </div>
);

export default ErrorIconHeader;
